import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {TimelineModel} from '../../../shared/models/timeline.model';
import {CustomTimelineVersion} from '../../model/kamonal-model';
import { AppConfig } from '@mpt-fo/common/shared/config/app-config';

@Component({
	selector: 'app-web-timeline-template-v2',
	templateUrl: './web-timeline-template-v2.component.html',
	styleUrls: ['./web-timeline-template-v2.component.scss']
})
export class WebTimelineTemplateV2Component implements OnInit {
	@Output() goBack = new EventEmitter();
	@Input() steps: TimelineModel [] = [];
	@Input() title: string;
	@Input() subTitle: string;
	@Input() formTitle: string;
	@Input() formSubTitle: string;
	@Input() version = CustomTimelineVersion.version_1;
	@Input() showBackButton  = false;
	CustomTimelineVersion = CustomTimelineVersion;
 
	constructor(private config: AppConfig) {
	}

	get useMoniepointMfbLogo() {
		return this.config.USE_MONIEPOINT_MFB_LOGO
	}

	ngOnInit(): void {
	}

	previousRoute(){
		this.goBack.emit();
	}
}
